import { Component, Input } from '@angular/core';
import { ConfigService } from 'app/services';

@Component({
    selector: 'partner-mart-locations-group-inventory',
    templateUrl: './partner-mart-locations-group-inventory.component.html',
    styleUrls: [
        './partner-mart-locations-group-inventory.component.scss',
        '../../partner-mart-locations-root/partner-mart-locations-root.component.scss'
    ]
})
export class PartnerMartLocationsGroupInventoryComponent {
    @Input()
    public groupId: number = 0;

    @Input()
    public groupName: string = '';

    constructor(public configService: ConfigService) {
    }
}
